/**
 * Manages ellipsed text 'show more'/'show less' buttons.
 *
 * Supports line-based clamp (`ellipsed-text__line-clamp-N`) and height-based
 * clamp (`ellipsed-text__max-height-NAME`). The ellipsis and the buttons are
 * only shown when the clamped text actually overflows: this component adds the
 * `ellipsed-text--truncated` class to the wrapper when that is the case.
 */

const TRUNCATED_CLASS = 'ellipsed-text--truncated';
const SHOW_ALL_CLASS = 'ellipsed-text__show-all';

/**
 * Flags each collapsed ellipsed text whose content overflows its clamp so the
 * ellipsis and the toggle buttons become visible.
 */
function refreshTruncation() {
    document.querySelectorAll('.ellipsed-text').forEach(function (wrapper) {
        // The clamp is only measurable while collapsed.
        if (wrapper.classList.contains(SHOW_ALL_CLASS)) {
            return;
        }

        const text = wrapper.querySelector('.ellipsed-text__text');
        if (!text) {
            return;
        }

        const overflows = text.scrollHeight > text.clientHeight + 1;
        wrapper.classList.toggle(TRUNCATED_CLASS, overflows);
    });
}

module.exports = function () {
    $('#maincontent').on('click', '.ellipsed-text__link', function () {
        this.closest('.ellipsed-text').classList.toggle(SHOW_ALL_CLASS);
    });

    refreshTruncation();
    window.addEventListener('resize', refreshTruncation);
};
